/**
 * Zweck: Beschreibt die TypeScript-Bausteine für den Frontend-Bereich frontend/src/app/modules/shop/components/merkliste-action-info/shop.merkliste-action-info.component.ts.
 */
import {Component, Inject} from '@angular/core';
import {MAT_SNACK_BAR_DATA} from '@angular/material/snack-bar';
import {MerklistActionInfo} from '../../../../models/merklist-action-info';

/**
 * Zweck: Beschreibt class ShopMerklisteActionInfoComponent und ihren Daten- oder Funktionsvertrag.
 */
@Component({
    selector: 'app-shop-merkliste-action-info',
    templateUrl: 'shop.merkliste-action-info.component.html',
    styleUrls: ['shop.merkliste-action-info.component.scss'],
    standalone: false
})
export class ShopMerklisteActionInfoComponent {
/**
 * Beschreibt Methode constructor und ihren Rückgabevertrag.
 */
  constructor(@Inject(MAT_SNACK_BAR_DATA) public data: MerklistActionInfo) {

  }

/**
 * Beschreibt Methode keydown und ihren Rückgabevertrag.
 */
  keydown(event) {
    event.stopPropagation();
  }
}
